import {
  Component,
  OnInit,
} from '@angular/core';
import { Transition } from '@uirouter/core';
import {
  finalize,
  takeUntil,
} from 'rxjs/operators';

import {
  ApBaseComponent,
  BillingRepository,
  LoginAssistanceResultDto,
  ReceiptDto,
  ReceiptRequestDto,
  WebCommonStorageRepository,
} from 'webcommon';

@Component({
  selector: 'th-payment-summary',
  templateUrl: './th-payment-summary.component.html',
})
export class ThPaymentSummaryComponent extends ApBaseComponent implements OnInit {
  loading = false;
  loadError = false;
  errorMessage = '';
  loginAssistanceInfo: LoginAssistanceResultDto;
  url = '';
  receiptHtml = '';
  userId: string | null;
  txId: string;
  continueClicked = false;

  constructor(
    private billingRepository: BillingRepository,
    private transition: Transition,
    private webCommonStorageRepository: WebCommonStorageRepository,
  ) {
    super();
  }

  ngOnInit() {
    this.userId = this.webCommonStorageRepository.getUserId();
    this.txId = this.transition.params().txId;
    this.load();
  }

  private load() {
    this.loading = true;

    this.loadReciept();

  }

  private loadReciept() {
    const receiptRequestDto: ReceiptRequestDto = {
      LoginUserPatientId: this.userId,
      RecipientEnumText: 'CUST',
      RemoteSessionId: this.userId + new Date().toLocaleDateString(),
      TxId: +this.txId,
    };
    this.billingRepository.getReceiptHtml(receiptRequestDto).pipe(
      finalize(() => this.onLoadComplete()),
      takeUntil(this.onDestroy$),
    ).subscribe(
      (data: ReceiptDto) => this.onLoadSuccess(data),
      () => this.onLoadError(),
    );
  }

  private onLoadComplete() {
    this.loading = false;
  }

  private onLoadError() {
    this.loadError = true;
  }

  private onLoadSuccess(result: ReceiptDto) {
    this.loadError = false;
    this.receiptHtml = result.ReceiptHtml;
  }

  print() {
    window.print();
  }

  done() {
    window.close();
    this.continueClicked = true;
  }
}
